import { InstagramEmbed } from '@bnnvara/embeds';
import { GridItem } from '@bnnvara/grids';
import React from 'react';

const ComposableInstagram = (props) => (
  <GridItem
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartMd="2"
    columnEndMd="span 10"
    columnStartLg="3"
    columnEndLg="11"
  >
    <InstagramEmbed {...props} />
  </GridItem>
);

export default ComposableInstagram;
